<template>
  <div>
    <div class="application3">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <div class="list">
            <div>
              <img src="../../assets/images/application/application3-1.jpg" alt />
              <img src="../../assets/images/application/application3-2.jpg" alt />
            </div>
            <div>
              <img src="../../assets/images/application/application3-3.jpg" alt />
            </div>
            <div>
              <img src="../../assets/images/application/application3-4.jpg" alt />
            </div>
          </div>
        </div>
      </module1>
    </div>
    <div class="mobile-application3">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>{{ a.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>{{ b.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item>
              <img :src="getImg(`application3-1.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
            <el-carousel-item>
              <img :src="getImg(`application3-2.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
            <el-carousel-item style="display: flex; justify-content: space-around;">
              <img :src="getImg(`application3-3.jpg`)" alt="Carousel Image" style="width: 50%; object-fit: contain;">
              <img :src="getImg(`application3-4.jpg`)" alt="Carousel Image" style="width: 50%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application3",
  metaInfo: {
    title:
      "智慧旅游可视化管理_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "智慧景区,智慧旅游,景区可视化,景区大数据分析决策,景区VR,旅游三维地图,景区三维地图"
      },
      {
        name: "description",
        content:
          "景点地图标注、景点VR游览、游览路线可视化、公共服务设施管理、景区客流量统计分析、消防设备可视化管理、景区管理辅助决策等。通过智慧旅游建设,提高旅游生态环境检测和保护的能力,提高对游客及工作人员的安全检测和保护能力,提高对景区综合管理监控能力,提高旅游业务的服务能力。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧旅游可视化管理",
        p:
          "景点地图标注、景点VR游览、游览路线可视化、公共服务设施管理、景区客流量统计分析、消防设备可视化管理、景区管理辅助决策等。通过智慧旅游建设，提高旅游生态环境检测和保护的能力……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p: "智慧景区、智慧旅游、景区大数据分析决策等。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "景点地图标注、景点VR游览、游览路线可视化、公共服务设施管理、景区客流量统计分析、消防设备可视化管理、景区管理辅助决策等。通过智慧旅游建设，提高旅游生态环境检测和保护的能力，提高对游客及工作人员的安全检测和保护能力，提高对景区综合管理监控能力，提高旅游业务的服务能力。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application3 {
  .list {
    font-size: 0;
    img {
      width: 100%;
    }
    > div {
      display: inline-block;
      &:nth-child(1) {
        width: 584px;
        margin-right: 20px;
        > img:nth-child(1) {
          margin-bottom: 20px;
        }
      }
      &:nth-child(2) {
        width: 282px;
        margin-right: 20px;
      }
      &:nth-child(3) {
        width: 282px;
      }
    }
  }
}
.mobile-application3 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application3 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application3 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application3.vue